import { useState, useContext } from "react";
import { ButtonState } from "@jcharlesworthuk/your-mum-frontend/models";
import * as Sentry from '@sentry/browser';
import { isNullOrEmpty } from "@jcharlesworthuk/your-mum-core/dist/functions";
import { LoggedInContext, SurveyManagerContext, SurveyManagerActionType } from "@Contexts";
import { PrivateApiClient } from "../ApiClient";
import { InputChangeDelegate } from "@jcharlesworthuk/your-mum-frontend/helpers/InputDelegates";
import { SurveyTemplate } from "@Models/SurveyTemplate";
import { SurveyTemplateDto } from "@Dtos";
import { UpdateSurveyTemplateWriteModel } from "@ApiModels";
type Fields = {
    newQuestionText: string
}

function isValid(fields: Fields) {
    return !isNullOrEmpty(fields.newQuestionText);
}

export const useChangeSurveyTemplate = (template: SurveyTemplate, fieldName: keyof UpdateSurveyTemplateWriteModel) => {
    const [fields, setFields] = useState<Fields>({
        newQuestionText: template[fieldName] || ''
    });
    const [buttonState, setButtonState] = useState<ButtonState>(ButtonState.Disabled);
    const [error, setError] = useState<string | 'exists' | undefined>(undefined);
    const { currentUser } = useContext(LoggedInContext);
    const { dispatch } = useContext(SurveyManagerContext);

    const registerInputChangeHandler = function (id: string) {
        const handler: InputChangeDelegate = e => {
            const newFields = {
                ...fields,
                [id]: e.currentTarget.value
            };
            setFields(newFields);
            setButtonState(isValid(newFields) ? ButtonState.Enabled : ButtonState.Disabled);
        }
        return handler;
    }


    const handleSubmitForm = (callback: () => void) => {
        return (e: React.FormEvent<HTMLFormElement>) => {
            e.preventDefault();
            const fetchDataAction = async () => {
                setButtonState(ButtonState.Working);
                if (!isValid(fields)) {
                    setError('Ensure you have entered all fields');
                    return;
                }
                setError(undefined);
                if (!isValid(fields)) return;
                try {
                   const apiClient = new PrivateApiClient().withUser(currentUser);
                    await apiClient.updateSurveyTemplate({
                        [fieldName]: fields.newQuestionText
                    })
                    dispatch({ type: SurveyManagerActionType.QuestionTextChanged, stringValue: fields.newQuestionText, changedFieldName: fieldName })
                    setButtonState(ButtonState.Enabled);
                    callback();
                } catch (e) {
                    console.error(e);
                    Sentry.captureException(e);
                    setError(e.message);
                }
            };
            fetchDataAction();
        }
    }

    return {
        fields,
        buttonState,
        registerInputChangeHandler,
        error,
        handleSubmitForm
    };
}